import styled from 'styled-components';

/**
 * Main container for OC Chat Widget
 * Provides default sizing that can be overridden by external CSS
 * Uses 'oc-chat-widget-container' class for easy CSS targeting
 */
export const OcChatWidgetContainer = styled.div.attrs({
  className: 'oc-chat-widget-container',
})`
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
`;
